import React from 'react';
import styles from './style.less';
const TopTips = ({ text, children, className }) => {
  return (
    <div className={`${styles['top-tips']} ${className}`}>
      {text}
      {children}
    </div>
  );
};
export default TopTips;
